module.exports = __webpack_public_path__ + "static/media/raj.b3f82523.png";